<template>
    <div>
        <board-list-link :boardData="boardData" :listLayout="listLayout"></board-list-link>
    </div>
</template>

<script>
import BoardListLink from "@/components/board/BoardListLink";
import boardFilterUtil from "@/components/board/boardFilterUtil";
import boardTemplateUtil from "@/components/board/boardTemplateUtil";
import alertMixin from "@/mixins/alertMixin";

export default {
    name: "BoardHomeComponent",
    mixins: [alertMixin, boardFilterUtil, boardTemplateUtil],
    components: {BoardListLink,},
    props: {
        boardType: ''
    },
    provide() {
        return {
            setPage: this.setPage,
            setFilter: this.setFilter,
        }
    },
    data() {
        return {
            listLayout: '',
            getFunc: '',
            listApiParamSet: {},
            boardData: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initConfig()
    },
    mounted() {
        this.getList();
    },
    beforeDestroy() {

    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let boardTemplateConfig = this.returnBoardTemplateConfig(this.boardType);
            this.listLayout = boardTemplateConfig.listLayout;
            let boardFilterConfig = this.returnBoardFilterConfig(this.boardType);
            this.getFunc = boardFilterConfig.getFunc;
            this.listApiParamSet = boardFilterConfig.listApiParamSet;
        },
        getList() {
            let params = this.listApiParamSet
            try {
                this.$api.$board[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnListType(res.Info.type)
                    if (type === true) {
                        this.boardData = this.$_.orderBy(res.List, ['wr_datetime'],['desc']);
                    } else {
                        this.errorAlert(type)
                    }
                })

            } catch (e) {
                console.log(e)
            }
        },
        returnListType(type) {
            switch (type) {
                case 1:
                    return true
                default:
                    return '게시글 목록을 불러올 수 없습니다.'
            }
        },


    },
    watch: {},
}
</script>

<style scoped>

</style>
